<template>
    <accordion-setting
        id="settingsButton"
        title="Configurações Botão"
        :visible="visible"
    >
        <!--  CONFIGURAÇÃO DE TEXTO  -->
         <div class="py-2 w-100">
            <label
                class="font-14"
            >
                Texto do botão
            </label>

            <input
                v-model="text"
                class="form-control"
                type="text"
            />
        </div>

        <!-- CONFIGURAÇÃO DE TIPO -->
        <div class="py-2 w-100">
            <setting-frame-button-type
                :item="item"
                @onChangeButtonType="onChangeButtonType"
            />
        </div>

        <!-- CONFIGURAÇÃO DE ALVO -->
        <div
            class="py-2 w-100"
            v-if="item
                && item.frameContent.settings.type == 'url'
            "
        >
            <setting-frame-button-target
                :item="item"
                @onChangeButtonTarget="onChangeButtonTarget"
            />
        </div>

        <!-- CONFIGURAÇÃO DE URL -->
        <div
            class="row"
            v-if="item 
                && item.frameType == 'button'
                && item.frameContent.settings.type == 'url'
            "
        >
            <div class="col-12 form-group">
                <label
                    class="font-14"
                >
                    URL
                </label>
                
                <input
                    v-model="url"
                    type="url"
                    name
                    id="URL-input"
                    class="form-control"
                    placeholder="url com https"
                    required
                />
            </div>
        </div>
            
        <!-- CONFIGURAÇÃO DE WHATSAPP  -->
        <div
            class="py-2"
            v-if="item
                && item.frameType == 'button'
                && item.frameContent.settings.type == 'whatsapp'
            "
        >
            <div class="row">
                <div class="col-4 form-group">
                    <label
                        class="font-14"
                    >
                        DDI
                    </label>

                    <input
                        type="number"
                        v-model="idd"
                        class="form-control"
                        placeholder="DDI"
                        required
                        id="IDD-input"
                    />
                </div>

                <div class="col-8 form-group">
                    <label
                        class="font-14"
                    >
                        DDD + Numero
                    </label>

                    <input
                        v-model="phone"
                        v-mask="'###########'"
                        type="tel"
                        class="form-control"
                        placeholder="DDD+Número"
                        required
                    />
                </div>
            </div>
        </div>
            
        <!-- CONFIGURAÇÃO DE TAMANHO -->
        <div class="py-2">
            <setting-frame-button-size
                :item="item"
                @onChangeButtonSize="onChangeButtonSize"
            />
        </div>
            
        <!-- CONFIGURAÇÃO DE LARGURA -->
        <div class="py-2">
            <setting-frame-width
                :item="item"
                @onChangeWidth="onChangeWidth"
            />
        </div>

        <!-- CONFIGURAÇÃO DE COR DO TEXTO -->
        <div class="py-2">
            <setting-frame-style-color
                :item="item"
                @onChangeStyleColor="onChangeStyleColor"
            />
        </div>

        <!-- CONFIGURAÇÃO DE ALINHAMENTO -->
        <div class="py-2">
            <setting-frame-style-text-align
                :item="item"
                @onChangeStyleTextAlignLock="onChangeStyleTextAlignLock"
                @onChangeStyleTextAlign="onChangeStyleTextAlign"
            />
        </div>

        <!-- CONFIGURAÇÃO DE TAMANHO DA FONTE -->
        <div class="py-2">
            <setting-frame-style-font-size
                :item="item"
                @onChangeStyleFontSize="onChangeStyleFontSize"
                @onChangeStyleFontSizeLock="onChangeStyleFontSizeLock"
            />
        </div>
        
        <!-- CONFIGURAÇÃO DE ESPESSURA DA FONTE -->
        <div class="py-2">
            <setting-frame-style-font-weight
                :item="item"
                @onChangeStyleFontWeight="onChangeStyleFontWeight"
                @onChangeStyleFontWeightLock="onChangeStyleFontWeightLock"
            />
        </div>

        <!-- CONFIGURAÇÃO DE BORDA ARREDONDADA -->
        <div class="py-2">
            <setting-frame-style-border-radius
                :item="item"
                @onChangeStyleBorderRadius="onChangeStyleBorderRadius"
                @onChangeStyleBorderRadiusLock="onChangeStyleBorderRadiusLock"
            />
        </div>

        <!-- CONFIGURAÇÃO DE COR DE FUNDO -->
        <div class="py-2">
            <setting-frame-background-color
                :item="item"
                :isStyleExtra="true"
                @onChangeBackgroundColor="onChangeBackgroundColor"
            />
        </div>

        <!-- CONFIGURAÇÃO DE MARGIN -->
        <div class="py-2">
                <setting-frame-margin
                    :item="item"
                    @onChangeMargin="onChangeMargin"
                    @onChangeMarginMobile="onChangeMarginMobile"
                    @onChangeLockMarginMobile="onChangeLockMarginMobile"
                />
            </div>
            
        <!-- CONFIGURAÇÃO DE PADDING -->
        <div class="py-2">
            <setting-frame-padding
                :item="item"
                @onChangePadding="onChangePadding"
                @onChangePaddingMobile="onChangePaddingMobile"
                @onChangeLockPaddingMobile="onChangeLockPaddingMobile"
            />
        </div>
    </accordion-setting>
</template>

<script>
import SettingFrameWidth from "../atoms/SettingFrameWidth.vue";
import AccordionSetting from '../atoms/AccordionSetting.vue';
import SettingFrameButtonSize from '../atoms/SettingFrameButtonSize.vue';
import SettingFrameButtonTarget from '../atoms/SettingFrameButtonTarget.vue';
import SettingFrameButtonType from '../atoms/SettingFrameButtonType.vue';
import SettingFrameStyleColor from '../atoms/SettingFrameStyleColor.vue';
import SettingFrameStyleTextAlign from '../atoms/SettingFrameStyleTextAlign.vue';
import SettingFrameStyleFontSize from '../atoms/SettingFrameStyleFontSize.vue';
import SettingFrameStyleFontWeight from '../atoms/SettingFrameStyleFontWeight.vue';
import SettingFrameStyleBorderRadius from '../atoms/SettingFrameStyleBorderRadius.vue';
import SettingFrameBackgroundColor from '../atoms/SettingFrameBackgroundColor.vue';
import SettingFrameMargin from '../atoms/SettingFrameMargin.vue';
import SettingFramePadding from '../atoms/SettingFramePadding.vue';

export default {
    name: "SettingsFrameButton",
    components: {
        SettingFrameWidth,
        AccordionSetting,
        SettingFrameButtonSize,
        SettingFrameButtonTarget,
        SettingFrameButtonType,
        SettingFrameStyleColor,
        SettingFrameStyleTextAlign,
        SettingFrameStyleFontSize,
        SettingFrameStyleFontWeight,
        SettingFrameStyleBorderRadius,
        SettingFrameBackgroundColor,
        SettingFrameMargin,
        SettingFramePadding,
    },
    props: {
        item: {
            type: Object,
            required: true
        },
        visible: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            text: this.item.frameContent.text,
            phone: this.item.frameContent.dataPhone.phone,
            idd: this.item.frameContent.dataPhone.idd,
            url: this.item.frameContent.ref,
        }
    },  
    methods: {
        handleSaveFrameConfig() {
            this.$emit("saveItemChanges", this.item);
        },
        onChangeWidth(item) {
            this.item.grid = item.grid;
            this.item.gridMobile = item.gridMobile;

            this.handleSaveFrameConfig();
        },
        onChangeButtonSize(item) {
            this.item.frameContent.settings.size = item.frameContent.settings.size;

            this.handleSaveFrameConfig();
        },
        onChangeButtonType(item) {
            this.item.frameContent.settings.type = item.frameContent.settings.type;

            this.handleSaveFrameConfig();
        },
        onChangeButtonTarget(item) {
            this.item.frameContent.settings.target = item.frameContent.settings.target;

            this.handleSaveFrameConfig();
        },
        onChangeStyleColor(color) {
            this.item.extra.style.color = color;

            this.handleSaveFrameConfig();
        },
        onChangeStyleTextAlignLock(lock) {
            this.item.extra.style_text_align_lock = lock;

            this.handleSaveFrameConfig();
        },
        onChangeStyleTextAlign(align) {
            this.item.extra.style.textAlign = align;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontSize(fontSize) {
            this.item.extra.style.fontSize = fontSize;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontSizeLock(isLock) {
            this.item.extra.style_font_size_lock = isLock;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontWeight(fontWeight) {
            this.item.extra.style.fontWeight = fontWeight;

            this.handleSaveFrameConfig();
        },
        onChangeStyleFontWeightLock(isLock) {
            this.item.extra.style_font_weight_lock = isLock;

            this.handleSaveFrameConfig();
        },
        onChangeStyleBorderRadius(borderRadius) {
            this.item.extra.style.borderRadius = borderRadius;

            this.handleSaveFrameConfig();
        },
        onChangeStyleBorderRadiusLock(isLock) {
            this.item.extra.style_border_radius_lock = isLock;

            this.handleSaveFrameConfig();
        },
        onChangeBackgroundColor(color) {
            this.item.extra.style.backgroundColor = color.backgroundColor;

            this.handleSaveFrameConfig();
        },
        onChangePadding(value) {
            this.item.extra.padding = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangePaddingMobile(value) {
            this.item.extra.padding_mobile = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeLockPaddingMobile(value) {
            this.item.extra.padding_mobile_lock = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeMargin(value) {
            this.item.extra.margin = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeMarginMobile(value) {
            this.item.extra.margin_mobile = value;
                            
            this.handleSaveFrameConfig();
        },
        onChangeLockMarginMobile(value) {
            this.item.extra.margin_mobile_lock = value;
                            
            this.handleSaveFrameConfig();
        },
    },
    watch: {
        url() {
            this.item.frameContent.ref = this.url;

            this.handleSaveFrameConfig();
        },
        idd() {
            this.item.frameContent.dataPhone.idd = this.idd;

            this.handleSaveFrameConfig();
        },
        phone() {
            this.item.frameContent.dataPhone.phone = this.phone;
            
            this.handleSaveFrameConfig();
        },
        text() {
            this.item.frameContent.text = this.text;

            this.handleSaveFrameConfig();
        },
    },
    created() {
        if (!this.item.extra) {
            this.item.extra = {};
        }

        if (typeof this.item.extra.style === 'undefined' || this.item.extra.style === null) {
            this.item.extra.style = {
                fontSize: '',
                fontWeight: '',
                textAlign: '',
                borderRadius: '',
                color: '',
                backgroundColor: ''
            };
        }


        if (typeof this.item.extra.style_font_size_lock === 'undefined' || this.item.extra.style_font_size_lock === null) {
            this.item.extra.style_font_size_lock = true;
        }

        if (typeof this.item.extra.style.fontSize === 'undefined' || this.item.extra.style.fontSize === null || this.item.extra.style.fontSize === '') {
            this.item.extra.style.fontSize = '16px';
        }

        if (typeof this.item.extra.style_font_weight_lock === 'undefined' || this.item.extra.style_font_weight_lock === null) {
            this.item.extra.style_font_weight_lock = true;
        }

        if (typeof this.item.extra.style.fontWeight === 'undefined' || this.item.extra.style.fontWeight === null || this.item.extra.style.fontWeight === '') {
            this.item.extra.style.fontWeight = 700;
        }

        if (typeof this.item.extra.style_text_align_lock === 'undefined' || this.item.extra.style_text_align_lock === null) {
            this.item.extra.style_text_align_lock = true;
        }

        if (typeof this.item.extra.style.textAlign === 'undefined' || this.item.extra.style.textAlign === null || this.item.extra.style.textAlign === '') {
            this.item.extra.style.textAlign = 'left';
        }

        if (typeof this.item.extra.style.borderRadius === 'undefined' || this.item.extra.style.borderRadius === null) {
            this.item.extra.style.borderRadius = '0px';
        }

        if (typeof this.item.extra.style.color === 'undefined' || this.item.extra.style.color === null) {
            this.item.extra.style.color = '';
        }

        if (typeof this.item.extra.style.backgroundColor === 'undefined' || this.item.extra.style.backgroundColor === null) {
            this.item.extra.style.backgroundColor = '';
        }
    },
};
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/molecules/SettingsFrameButton.vue